export const PAYSLIPS = [
  { emp: "Priya Sharma",    month: "February 2026", gross: "$7,667", deductions: "$1,534", net: "$6,133", status: "Paid" },
  { emp: "Marcus Johnson",  month: "February 2026", gross: "$8,750", deductions: "$1,750", net: "$7,000", status: "Paid" },
  { emp: "Aiko Tanaka",     month: "February 2026", gross: "$6,500", deductions: "$1,300", net: "$5,200", status: "Paid" },
  { emp: "Carlos Rivera",   month: "February 2026", gross: "$5,917", deductions: "$1,183", net: "$4,734", status: "Paid" },
];

export const REIMBURSEMENTS = [
  { emp: "Marcus Johnson",  type: "Travel",    amount: "$342",   date: "Mar 3", status: "Approved" },
  { emp: "Priya Sharma",    type: "Equipment", amount: "$1,200", date: "Mar 5", status: "Pending"  },
  { emp: "Carlos Rivera",   type: "Training",  amount: "$599",   date: "Mar 1", status: "Approved" },
  { emp: "Liam O'Brien",    type: "Meals",     amount: "$87",    date: "Mar 7", status: "Pending"  },
];
